import axios from 'axios'
import { environmentConfig } from '@/config/enviromentConfig'

const base = () => environmentConfig.integrationService

// service.madapi-integration. Every call names the enterprise serviceId (252, MADAPI_BLG_CM) and the
// tier's productId / plan id so the service resolves the BLG CM app block rather than a default.
export default class MadapiService {
  // pr_GetUser row: { Status, StatusId, ProductId, ExternalProductId, ... }. createIfMissing=false so a
  // pre-subscribe lookup never seeds a Pending row for a number that is only being checked.
  static async getUser({ msisdn, serviceId }) {
    const response = await axios.get(`${base()}/get-user`, {
      params: { msisdn, serviceId, createIfMissing: false }
    })
    return response.data
  }

  // -> { otpSent, reason, status, redirectUrl? }. purpose marks a web-recruitment PIN (SIM check
  // before subscribing) so the service skips its subscriber gate.
  static async requestOtp({ msisdn, serviceId, productId }) {
    const response = await axios.post(`${base()}/otp/request`, {
      msisdn,
      serviceId,
      productId,
      purpose: 'web-recruitment',
      registrationChannel: 'WEB'
    })
    return response.data
  }

  // -> { valid, reason }
  static async verifyOtp({ msisdn, serviceId, productId, otp }) {
    const response = await axios.post(`${base()}/otp/verify`, { msisdn, serviceId, productId, otp })
    return response.data
  }

  // Direct MADAPI Subscription v2 subscribe. transaction_id is the banner composite the service
  // splits into clickId / campaignId / publisherId and queues for the Comviva activation callback;
  // correlationId travels to MTN as the transactionId header; evinaTransactionId is the kit's ti,
  // which the service checks with Evina before calling MTN (403 EvinaBlocked when refused).
  static async subscribe({ msisdn, serviceId, productId, networkServiceId, registrationChannel, transactionId, correlationId, evinaTransactionId }) {
    const response = await axios.post(`${base()}/subscribe`, {
      msisdn,
      serviceId,
      productId,
      externalProductId: networkServiceId,
      registrationChannel,
      transaction_id: transactionId || undefined,
      correlationId,
      evinaTransactionId: evinaTransactionId || undefined
    })
    return response.data
  }

  // Evina DCBprotect kit for the confirm step -> { result: 'success' | 'skipped' | 'fail', ti, token,
  // script (base64), reason }. transaction_id is only a dashboard filter on Evina's side.
  static async getEvinaScript({ targetElement, msisdn, serviceId, productId, transactionId }) {
    const response = await axios.post(`${base()}/evina/script`, {
      targetElement,
      msisdn: msisdn || undefined,
      serviceId,
      productId,
      transaction_id: transactionId || undefined
    })
    return response.data
  }

  static isEvinaBlocked(error) {
    return error?.response?.status === 403 && error.response.data?.message === 'EvinaBlocked'
  }

  // The message MTN or the service attached to a failed call, for the failure page.
  static errorMessage(error) {
    const data = error?.response?.data
    if (!data) return ''
    if (typeof data === 'string') return data
    return data.statusMessage || data.description || data.message || data.error || ''
  }
}
